<div class="templates-list-container">
  <table>
    <thead>
      <tr>
        <th class="table-check pr-0">
          <label *ngIf="!isSingleSelectionOnly" class="default-label custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input select-all"
              (change)="onSelectAllTemplates($event)"
              [(ngModel)]="allTemplatesSelected"
            />
            <span class="custom-control-indicator"></span>
          </label>
        </th>
        <th class="table-name" i18n>Template</th>
        <th class="table-id" *ngIf="!isLibrarySelection" i18n>Template ID</th>
        <th class="table-preview" i18n>Preview</th>
      </tr>
    </thead>
    <tbody #tableBody (scroll)="debouncedUpdateBorderOnScrollEnd()">
      <tr
        *ngFor="let template of visibleTemplates"
        [class.selected]="template.selected"
        (click)="onRowSelection(template)"
      >
        <td class="table-check pr-0">
          <label
            (click)="preventPropagationOnClick($event)"
            class="custom-control custom-checkbox select-template"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              [checked]="template.selected"
              (click)="onRowSelection(template)"
            />
            <span class="custom-control-indicator"></span>
          </label>
        </td>
        <td class="table-name">
          <span class="table-name-icon-container">
            <i
              class="mr-3"
              ngClass="{{
                template?.columns?.length > 0 ? 'cc-icon cc-icon-workflow' : 'cc-icon cc-icon-nav-bars'
              }}"
            ></i>
            {{ template.name }}
          </span>
        </td>
        <td class="table-id" *ngIf="!isLibrarySelection">{{ template.uniqueAppId }}</td>
        <td class="table-preview">
          <a class="preview-link" (click)="$event.stopPropagation(); onPreviewClick(template)">
            <span i18n>Preview</span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="bottom-border" [hidden]="hideBottomBorder"></div>
